<template>
  <div class="dakoku-syuusei">
    <h3>打刻修正申請<span v-if="dakokuSyuusei?.is_torikeshi" class="torikeshi">（打刻取消）</span></h3>

    <div class="item">
      <b class="title">打刻日</b>
      <span>{{ dateFormat(dakokuSyuusei.dakoku_date) }}</span>
    </div>

    <template v-if="dakokuSyuusei?.is_torikeshi">
      <div class="item">
        <b class="title">就業時間</b>
      </div>

      <div class="item">
        <b class="title">出勤</b>
      </div>

      <div class="item">
        <b class="title">退勤</b>
      </div>

      <div class="item">
        <b class="title">外出</b>
      </div>

      <div class="item">
        <b class="title">戻り</b>
      </div>

      <div class="item">
        <b class="title">休憩</b>
      </div>
    </template>

    <template v-else>
      <div class="item">
        <b class="title">就業場所</b>
        <div class="before-after">
          <p>{{ form.syuugyou_basyo_name }}</p>
        </div>
      </div>

      <div class="item">
        <b class="title">就業時間</b>
        <div class="before-after">
          <p v-if="workTime.length > 0">{{ workTime[0].disp_work_time }}</p>
          <p v-else>無し</p>
        </div>
      </div>

      <div class="item">
        <b class="title">出勤</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_syukkin_datetime ?? '記録なし' }}</p>
          <p class="arrow">→</p>
          <p class="after">{{ dakokuSyuusei.syukkin_datetime ?? '記録なし' }}</p>
        </div>
      </div>

      <div class="item">
        <b class="title">退勤</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_taikin_datetime ?? '記録なし' }}</p>
          <p class="arrow">→</p>
          <p class="after">{{ dakokuSyuusei.taikin_datetime ?? '記録なし' }}</p>
        </div>
      </div>

      <div class="item">
        <b class="title">外出</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_gaisyutsu_datetime ?? '記録なし' }}</p>
          <p class="arrow">→</p>
          <p class="after">{{ dakokuSyuusei.gaisyutsu_datetime ?? '記録なし' }}</p>
        </div>
      </div>

      <div class="item">
        <b class="title">戻り</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_modori_datetime ?? '記録なし' }}</p>
          <p class="arrow">→</p>
          <p class="after">{{ dakokuSyuusei.modori_datetime ?? '記録なし' }}</p>
        </div>
      </div>

      <div class="item">
        <b class="title">休憩</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_kyuukei_times ?? '記録なし' }}</p>
          <p class="arrow">→</p>
          <p class="after">{{ dakokuSyuusei.kyuukei_times ?? '記録なし' }}</p>
        </div>
      </div>
    </template>

  </div>

  <modal :title="dakokuSyuuseiModalParts.title">
    <dialog-dakoku-syuusei :syuuseiData="syuuseiData" :koyouKeiyakuId="form.koyou_keiyaku_id ?? undefined"
      @send="sendDakokuSyuusei" @cancel="canceldDakokuSyuusei">
    </dialog-dakoku-syuusei>
  </modal>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { dateFormat, timeFormat } from "@/filters/common";
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuTimeForDetail, Shinsei } from '@/types/Shinsei';
import { useDakokuSyuuseiModal } from '@/composable/modal/dakoku-syuusei';
import { useInit } from '@/composable/shinsei/dakoku-syuusei/init';
import dayjs from 'dayjs'
import DakokuSyuuseiModal from "../../../dakoku/DakokuSyuusei.vue";

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    isSyouninFlow: {
      type: Boolean,
      default: false
    },
    workTime: {
      type: Object as () => KoyouKeiyakuTimeForDetail[],
      default: null
    },
  },
  setup(props) {

    const { dakokuSyuusei } = useInit(props.form)
    console.log('props.form', props.form)
    const workTime = props.workTime

    // エラー取得
    const { getError } = useForm();
    const dakokuSyuuseiModal = useDakokuSyuuseiModal();

    const timeFormater = (val: string) => {
      const date = dayjs().format('YYYY-MM-DD') + ' ' + val
      return timeFormat(date)
    }

    /** 打刻修正ダイアログのオープン） */
    const openDakokuSyuuseiDialog = async () => {
      await dakokuSyuuseiModal.setDataForShinsei(dakokuSyuusei)
      dakokuSyuuseiModal.openDakokuSyuuseiModal()
    }

    /** 打刻修正の実行（申請提出） */
    const sendDakokuSyuusei = async (result: boolean) => {
      await dakokuSyuuseiModal.clearData()
      dakokuSyuuseiModal.closeDakokuSyuuseiModal()
    }

    /** 打刻修正ダイアログのクローズ */
    const canceldDakokuSyuusei = async () => {
      dakokuSyuuseiModal.closeDakokuSyuuseiModal()
      await dakokuSyuuseiModal.clearData()
    }

    const timeFormatter = (time: string): string => {
      return timeFormat(new Date() + ' ' + time)
    }

    return {
      dakokuSyuusei,
      getError,
      dateFormat,
      timeFormat,
      timeFormater,
      dakokuSyuuseiModalParts: dakokuSyuuseiModal.dakokuSyuuseiModalParts,
      dakokuSyuuseiModalRef: dakokuSyuuseiModal.dakokuSyuuseiModalRef,
      syuuseiData: dakokuSyuuseiModal.syuuseiData,
      sendDakokuSyuusei,
      canceldDakokuSyuusei,
      openDakokuSyuuseiDialog,
      timeFormatter,
      workTime,
    }
  },
  components: {
    'dialog-dakoku-syuusei': DakokuSyuuseiModal,
  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>